import { ReportGroup } from '@/api/generatedApi';
import { Box } from '@mui/material';
import { useRef } from 'react';
import { ReportSample } from './ReportSample';

export const ReportGroupsList = ({
  groups,
  selectedGroupId,
}: {
  groups: ReportGroup[];
  selectedGroupId: string | undefined;
}) => {
  const hasScrolled = useRef(false);

  const selectedReference = (node: HTMLDivElement | undefined) => {
    if (node && !hasScrolled.current) {
      hasScrolled.current = true;
      node.scrollIntoView?.({ block: 'start' });
    }
  };

  return (
    <Box sx={{ overflowY: 'auto', height: '100%' }}>
      {groups.map((group, index) => {
        const isSelected = selectedGroupId !== undefined && group.id === selectedGroupId;
        return (
          <Box key={group.id} ref={isSelected ? selectedReference : undefined}>
            <ReportSample
              group={group}
              groupIndex={index + 1}
              isSelected={isSelected}
              isLastItem={index === groups.length - 1}
            />
          </Box>
        );
      })}
    </Box>
  );
};
